import React from 'react';
import { Hammer, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <section id="nosotros" className="py-24 bg-dark relative overflow-hidden" data-id="element-402">
      <div className="absolute right-0 bottom-0 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-403"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-404">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-405">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-406">
            <div className="w-16 h-16 rounded-2xl bg-dark-100 border border-white/10 flex items-center justify-center shadow-xl mb-8" data-id="element-407">
              <Hammer className="w-8 h-8 text-gold" data-id="element-408" />
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-409">
              Construimos Esto Para Contractors Que <br data-id="element-410" />
              <span className="text-gold" data-id="element-411">Merecen Más</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-400" data-id="element-412">
              <p data-id="element-413">
                Vimos a excelentes contractors perder trabajos contra
                competidores mediocres, simplemente porque su presencia digital
                se veía amateur.
              </p>
              <p data-id="element-414">
                Muchos pensaban que un website profesional costaba miles de
                dólares y meses de espera.{' '}
                <strong className="text-white" data-id="element-415">No tiene que ser así.</strong>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-gradient-to-br from-dark-100 to-dark-200 p-8 md:p-12 rounded-3xl border border-white/5 shadow-2xl" data-id="element-416">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-417">
              Nuestra Misión
            </h3>
            <p className="text-xl font-medium text-gold border-l-4 border-gold pl-6 py-2 mb-8" data-id="element-418">
              Darle a los contractors la presencia online premium que merecen —
              a un precio accesible, en tiempo récord, sin complicaciones.
            </p>

            <div className="space-y-4" data-id="element-419">
              {['Website profesional completo por $250', 'Listo en menos de 72 horas', 'Sin mensualidades obligatorias', 'Sin contratos largos ni sorpresas'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-420">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-421" />
                  <span className="text-white font-medium" data-id="element-422">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}